import { FormControl, Grid, IconButton, InputLabel, Select, Table, TableBody
    , TableCell, TableRow, TextField, Typography, Box } from '@mui/material';
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../services/api";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, add, remove
    , setValidations, activeValidations } from '../redux/puntuacionDetalleSlice';
import * as puntuacionService from "../services/puntuacionService";
import DialogYesNo from './DialogYesNo';
import { FormHelperText as HelperText } from '@mui/material';

// Detalle 1 de la puntuacion: los valores de la escala. Cada fila es un
// puntuaciondetalle.
const PuntuacionDetalle = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.puntuacionDetalle.entity);
    const defaultEntity = useSelector((state) => state.puntuacionDetalle.defaultEntity);
    const validate = useSelector((state) => state.puntuacionDetalle.validationActive);
    const dispatch = useDispatch();
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [selectId, setSelectId] = useState(0);
    const [selectNumero, setSelectNumero] = useState(0);

    var validation = {
        AtLeastOneRow: {
            error: entity.length == 1 && entity[0].id == 0,
            message: "Debe haber por lo menos un valor de la escala",
        },
    }

    const idPuntuacion = parseInt(params.id || "0");

    const fetchEntity = useCallback(async () => {
        if (idPuntuacion <= 0) {
            dispatch(setEntity(defaultEntity));
            return;
        }

        const data = await puntuacionService.getsPuntuacionDetalle(idPuntuacion)
            .catch((err) => {
                console.log("Err: ", err);
                return [];
            });

        if (data == null || data.length == 0) {
            dispatch(setEntity(defaultEntity));
        }
        else {
            dispatch(setEntity(data.map((row) => ({ ...row, numero: row.id }))));
        }
    }, [])

    useEffect(() => {
        fetchEntity();
    }, [])

    useEffect(() => {
        dispatch(setValidations(messagesValidation()));
    }, [entity])

    const setItemValue = (numero, name, value) => {
        dispatch(setData({ numero: numero, name: name, value: value }))
    }

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    const deleteEntity = async () => {
        if (selectId > 0) {
            await puntuacionService.deletePuntuacionDetalle(selectId)
                .catch((err) => {
                    console.log("Err: ", err);
                });
        }

        dispatch(remove(selectNumero));
        fetchEntity();
    }

    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Valores de la escala (" + (entity != null ? entity.length : 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <IconButton disabled={isReadOnly || idPuntuacion <= 0} size="small" aria-label="Agregar Valor"
                    style={{ height: 10 }} onClick={() => {
                        dispatch(add(idPuntuacion));
                    }}>
                    <IconAddCircle />
                </IconButton>
            </Grid>
            <Grid container>
                <Table size="small">
                    <TableBody>
                        {entity.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell>
                                    <Grid container spacing={1} padding={0}>
                                        <Grid item xs={12} sm={3}>
                                            <TextField
                                                label="Valor"
                                                type="number"
                                                fullWidth
                                                value={row.valor}
                                                onChange={(e) => {
                                                    setItemValue(row.numero, "valor", e.target.value)
                                                }}
                                                disabled={isReadOnly}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <TextField
                                                label="Texto"
                                                fullWidth
                                                value={row.texto}
                                                onChange={(e) => {
                                                    setItemValue(row.numero, "texto", e.target.value)
                                                }}
                                                disabled={isReadOnly}
                                                size="small"
                                                inputProps={{ maxLength: 5 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Descripcion"
                                                fullWidth
                                                value={row.descripcion}
                                                onChange={(e) => {
                                                    setItemValue(row.numero, "descripcion", e.target.value)
                                                }}
                                                disabled={isReadOnly}
                                                size="small"
                                                inputProps={{ maxLength: 70 }}
                                            />
                                        </Grid>
                                        <Grid item xs={1} sm={1}>
                                            <IconButton aria-label="delete" disabled={isReadOnly} onClick={() => {
                                                if (row.id > 0) {
                                                    setSelectId(row.id);
                                                    setSelectNumero(row.numero);
                                                    setOpenDialogDelete(true);
                                                }
                                                else {
                                                    dispatch(remove(row.numero));
                                                }
                                            }}>
                                                <IconDelete />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <FormControl required fullWidth
                    error={
                        (validate.AtLeastOneRow && validation.AtLeastOneRow.error)
                    }>

                    <HelperText>
                        {validate.AtLeastOneRow && validation.AtLeastOneRow.error ? validation.AtLeastOneRow.message : ""}
                    </HelperText>
                </FormControl>
            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                openClose={() => { setOpenDialogDelete(!openDialogDelete); }}
                setYes={deleteEntity}
                setNo={() => { return }}
                titulo={"Borrar Valor"}
                texto={"Esta seguro de borrar el valor de la escala?"}
            ></DialogYesNo>
        </Grid>
    )
}

export default PuntuacionDetalle;